import {
  getActionNameWithStatus,
  getResetAction,
} from "../../constants/actions-methods";
import { requestStatus } from "../../constants/request";
import { serverApis } from "../../constants/server-apis";

export const saveProductionPickInboxReducer = (state = "", action) => {
  const actionName = serverApis.saveProductionPickInbox.actionName;
  switch (action.type) {
    case getActionNameWithStatus(actionName, requestStatus.SUCCESS):
      return action.json.message;

    case getResetAction(actionName):
      return "";
    default:
      return state;
  }
};
